import { render, staticRenderFns } from "./VersionsSearchBar.vue?vue&type=template&id=e303e708&lang=pug&"
import script from "./VersionsSearchBar.vue?vue&type=script&lang=js&"
export * from "./VersionsSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./VersionsSearchBar.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports